import React from 'react';
import { Broker } from './Broker';
export var EventsContext = React.createContext({
    subscribe: function () { return ({}); },
    publish: function () { return ({}); },
    close: function () { return ({}); },
    subscribeAll: function () { return ({}); },
});
export var Provider = EventsContext.Provider, Consumer = EventsContext.Consumer;
var publisher = Broker(); // one instance for all application.
export var EventsProvider = function (_a) {
    var children = _a.children, events = _a.events, globalData = _a.globalData;
    if (Boolean(globalData)) {
        publisher.setGlobalData(globalData);
    }
    if (events) {
        publisher.subscribeAll(events);
    }
    return React.createElement(Provider, { value: publisher }, children);
};
